import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaceFormsState } from '../state/pace-forms.state';

export const getPaceFormsState = createFeatureSelector<PaceFormsState>('paceForms');

export const getServiceActivityType = createSelector(getPaceFormsState, (formsState) => formsState.serviceActivity);
